<template>
	<el-dialog
		:title="title"
		:visible.sync="show"
		@open="filterAssigned"
		@closed="closedDialog"
		:show-close="false"
		:close-on-press-escape="false"
		:close-on-click-modal="false"
		width="500px"
	>
		<div class="margin-bottom-20">
			{{ warning }}
		</div>
		<div class="row margin-bottom-10">
			<div class="col-lg-12">

				<el-tabs
					v-if="devices.length"
					v-model="activeTab"
					type="card"
				>
					<el-tab-pane name="devices">
						<span slot="label">
							<i class="el-icon-monitor" /> {{ translations.navigation.devices }}
						</span>
						<el-checkbox-group v-model="assign.assigned">
							<div
								v-for="item in filteredDevices"
								:key="item.id"
								:label="item.id"
								class="margin-bottom-10"
								style="width: 100%"
							>
								<el-checkbox
									:label="item.id"
									border
								>
									{{ item.title }}
								</el-checkbox>
							</div>
						</el-checkbox-group>
					</el-tab-pane>
				</el-tabs>
			</div>
		</div>
		<div class="margin-bottom-20">
			<el-alert
				v-if="warningApply"
				:title="warningApply"
				:closable="false"
				type="error"
			/>
		</div>
		<div class="row">
			<div class="col-lg-12 align-right">
				<el-button
					@click="assignSelected()"
					:loading="processing"
					type="primary"
					native-type="submit"
					plain
				>
					{{ translations.labels.saveChanges }}
				</el-button>
				<el-button
					@click="closeDialog()"
					plain
				>
					{{ translations.labels.cancel }}
				</el-button>
			</div>
		</div>
	</el-dialog>
</template>

<script>
import { EventBus } from '@/services/event-bus'

export default {
    name: 'AssignToDevice',
	props: {
		current: Object,
		devices: Array,
		processing: Boolean,
		show: Boolean,
		title: String,
		type: String,
		warning: String,
		warningApply: String
	},
	data () {
		return {
			activeTab: 'devices',
			assign: {
				assigned: [],
				unassigned: [],
				presentationId: null,
				scheduleId: null,
			},
			filteredDevices: [],
			tempDevices: []
		}
	},
	methods: {
		filterAssigned () {
			this.assign = {
				assigned: [],
				unassigned: [],
				presentationId: this.type === 'presentation' ? this.current.id : null,
				scheduleId: this.type === 'schedule' ? this.current.id : null,
			}
			if (this.objectLength(this.current)) {
				this.tempDevices = this.clone(this.devices).filter(item =>item.settings.resolution === this.current.settings.resolution)
				this.tempDevices.forEach(item => {
					if (item.presentationId || item.scheduleId) {
						if (item.presentationId === this.current.id || item.scheduleId === this.current.id) {
							this.filteredDevices.push(item)
						}
					} else {
						this.filteredDevices.push(item)
					}
					if (item.presentationId === this.current.id) {
						this.assign.assigned.push(item.id)
					}
					if (item.scheduleId === this.current.id) {
						this.assign.assigned.push(item.id)
					}
				})
			}
		},
		closeDialog () {
			EventBus.$emit('close-assign')
		},
		closedDialog () {
			this.activeTab = 'devices'
			this.tempDevices = []
			this.filteredDevices = []
			this.assign = {
				assigned: [],
				unassigned: [],
				presentationId: null,
				scheduleId: null,
			}
			EventBus.$emit('closed-assign')
		},
		assignSelected () {
			this.assign.unassigned = []
			const temp = this.clone(this.filteredDevices).filter(item => !this.assign.assigned.includes(item.id))
			temp.forEach(item => {
				this.assign.unassigned.push(item.id)
			})
			EventBus.$emit('submit-assign', this.assign)
		}
	}
}
</script>
